import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Синхронизация данных из фида Я Товаров
 */
export const MerchantCenterFeedSyncContentType = '' as const;
export type MerchantCenterFeedSyncRequest = void;
export type MerchantCenterFeedSyncResponses = LinkCommonErrorResponses & {
    /**
     * @description Integration sync started successfully
     */
    '200': {};
};
export type MerchantCenterFeedSyncResponseSuccess = undefined;
export type MerchantCenterFeedSyncSearchParams = undefined;
export type MerchantCenterFeedSyncPathParameters = undefined;
export const MerchantCenterFeedSyncUrl = '/integrations/merchantcenter/start' as const;
export const MerchantCenterFeedSyncMethod = 'POST' as const;
export const getMerchantCenterFeedSyncUrl = (_params?: MerchantCenterFeedSyncPathParameters) =>
    MerchantCenterFeedSyncUrl;
